<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useBroadcast } from "~/stores/broadcast.store";
import DisabledHintButton from "~/components/ui/button/DisabledHintButton.vue";
import { useRouter } from "vue-router";
import { useChannels } from "~/stores/channel.store";
import { Channel } from "~/entities/channel";
import { ref } from "vue";
import ModalSelectChannel from "~/views/trigger/components/ModalSelectChannel.vue";
const { statistics } = storeToRefs(useBroadcast());
const router = useRouter();
const channelStore = useChannels();
const selectChannelOpened = ref<boolean>(false);
function onCreateBroadcastClick() {
  selectChannelOpened.value = true;
}
function onChannelSelected(c: Channel) {
  channelStore.setSelectedWabaChannel(c.id || null); // todo: возвращать boolean
  if (c.id) {
    router.push({ name: "broadcastSender" });
  }
}
</script>

<template>
  <div class="broadcast-header">
    <span class="broadcast-count">{{
      $tc("broadcast.header.list", statistics.length)
    }}</span>

    <DisabledHintButton
      v-if="false"
      :placement="'left'"
      :width="203"
      :height="44"
      :button-text="'Создать рассылку'"
      :hint-text="'Добавьте канал, чтобы создать рассылку'"
    />

    <PButton
      v-else
      :class="'broadcast-button'"
      :variant="'default'"
      :size="'small'"
      :color="'primary'"
      :disabled="false"
      :nuxt="false"
      :type="'button'"
      :block="false"
      @click="onCreateBroadcastClick"
    >
      Создать рассылку
    </PButton>
  </div>
  <ModalSelectChannel
    v-model:open="selectChannelOpened"
    :value="channelStore.selectedWabaChannelId"
    :options="channelStore.wabaChannels"
    @item-selected="onChannelSelected"
  />
</template>

<style scoped>
.broadcast-header {
  width: 100%;
  display: inline-flex;
  padding: var(--spacing-s, 16px);

  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  border: 1px solid var(--common-smog);
  background: var(--ui-white);
}

.broadcast-count {
  color: var(--typography-titles);
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 155.556% */
  letter-spacing: -0.18px;
}

.broadcast-button {
  width: 203px;
}
</style>
